import { render, staticRenderFns } from "./InformacaoEspecial.vue?vue&type=template&id=e7049b06"
import script from "./InformacaoEspecial.vue?vue&type=script&lang=js"
export * from "./InformacaoEspecial.vue?vue&type=script&lang=js"
import style0 from "./InformacaoEspecial.vue?vue&type=style&index=0&id=e7049b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports